import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
/**
AddUser
کامپوننتی برای افزودن کاربران به سازمان به صورت انفرادی یا گروهی.
شامل راهنمایی متنی برای پذیرنده و امکان دانلود فایل نمونه اکسل برای افزودن گروهی کاربران.
کامپوننت به صورت واکنش‌گرا طراحی شده و در دستگاه‌های موبایل، تبلت و دسکتاپ به خوبی نمایش داده می‌شود.
@param {object} props
@param {any} props.selectedOption - مقدار انتخاب شده در گزینه‌های رادیویی (option1 یا option2)
@param {function} props.setSelectedOption - تابع برای تغییر گزینه انتخاب شده
@returns JSX.Element
*/
export const AddUser = ({selectedOption,setSelectedOption,}: {selectedOption: any;setSelectedOption: any;}) => {
  return (
    <StackKit gap={4}>
      <StackKit sx={{ textAlign: "center" }}>
        <TypoGraphyKit variant="body1">پذیرنده گرامی ؛</TypoGraphyKit>
      </StackKit>
      <TypoGraphyKit variant="body1">
        در صورتی که میخواهید به صورت گروهی مشتریان خود را به سازمان اضافه نمایید
        لطفا ابتدا فایل اکسل را دانلود نموده و مشخصات کاربران را طبق موارد
        خواسته شده تکمیل نمایید و سپس فایل را آپلود نمایید. در غیر این صورت و
        تمایل به افزودن انفرادی کاربر گزینه افزودن انفرادی را انتخاب نمایید.{" "}
      </TypoGraphyKit>
      <StackKit direction={{xs:"column" , sm:'row'}} justifyContent={"space-between"} gap={4}>
        <RadioGroup value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)} sx={{ gap: 2, width: "100%" }}>
          <FormControlLabel value="option1"  sx={{ width: "100%", margin: "0 !important", justifyContent:{xs:'center',sm:'center',md:'start'} , alignItems:'center' }}
            control={
              <Radio sx={{ color: "white" }} />
            } 
            label={
              <TypoGraphyKit sx={{ color: "white" }}>افزودن کاربر به صورت انفرادی</TypoGraphyKit>
            }/>
          <StackKit direction={{xs:"column" , sm:'column',md:'row'}} justifyContent="space-between" alignItems="center" sx={{ width: "100%" }}>
            <FormControlLabel value="option2" 
              control={
                <Radio sx={{ color: "white" }} />
              } 
              label={
                <TypoGraphyKit sx={{ color: "white" }}>افزودن کاربران به صورت گروهی</TypoGraphyKit>
              }/>
            <StackKit direction={'row'} alignItems="center" sx={{ gap: 1, cursor: "pointer" }} onClick={(e) => {e.stopPropagation();}}>
              <FileDownloadOutlinedIcon style={{ color: "#3687FF" }} />
              <TypoGraphyKit variant="body1" sx={{ color: "#3687FF" }}>
                دریافت فایل نمونه اکسل
              </TypoGraphyKit>
            </StackKit>
          </StackKit>
        </RadioGroup>
      </StackKit>
    </StackKit>
  );
};

export default AddUser;
